<script setup lang="ts">
  import { onMounted, onUnmounted, ref } from "vue";
  import { useMainStore } from "~/stores";
  import OnlineCustomer from "./OnlineCustomer.vue";

  const visible = ref(false);
  const kefuRef = ref();
  const isMobileDevice = ref(false);

  const onBackTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getPopupContainer = () => {
    return document.body;
  };

  const addDraggableListener = () => {
    const draggable: HTMLElement | null = document.getElementById("page-tools");
    if (!draggable) return;
    let isDragging = false;
    let offsetX = 0;
    let offsetY = 0;

    // 移动端长按事件
    draggable.addEventListener("touchstart", (e: TouchEvent) => {
      isDragging = true;
      if (isMobileDevice.value) {
        document.body.style.overflow = "hidden";
      }
      const touch = e.touches[0];
      offsetX = touch.clientX - draggable.getBoundingClientRect().left;
      offsetY = touch.clientY - draggable.getBoundingClientRect().top;
      document.addEventListener("touchmove", touchMoveHandler);
    });

    const touchMoveHandler = (e: TouchEvent) => {
      if (isDragging) {
        const touch = e.touches[0];
        visible.value = false;
        const x = touch.clientX - offsetX;
        const y = touch.clientY - offsetY;
        // 限制拖动范围在可视窗口内
        draggable.style.left = `${Math.max(0, Math.min(window.innerWidth - draggable.offsetWidth, x))}px`;
        draggable.style.top = `${Math.max(0, Math.min(window.innerHeight - draggable.offsetHeight, y))}px`;

        // 确保元素右侧与窗口右侧重合
        if (parseInt(draggable.style.left) + draggable.offsetWidth + 6 > window.innerWidth) {
          draggable.style.left = `${window.innerWidth - draggable.offsetWidth - 6}px`;
        }

        if (parseInt(draggable.style.top) + draggable.offsetHeight + 50 > window.innerHeight) {
          draggable.style.top = `${window.innerHeight - draggable.offsetHeight - 70}px`;
        }
      }
    };

    // 触摸结束事件
    document.addEventListener("touchend", () => {
      isDragging = false;
      document.body.style.overflow = "auto";
      document.removeEventListener("touchmove", touchMoveHandler);
    });
  };

  const resizeHandler = () => {
    const width = window.innerWidth; // 获取窗口宽度
    // 假设我们想要获取宽度在300到500像素之间的间隔
    if (width >= 50 && width <= 768) {
      isMobileDevice.value = true;
    } else {
      isMobileDevice.value = false;
    }
  };

  const listenerResize = () => {
    window.addEventListener("resize", resizeHandler);
  };

  const store = useMainStore();

  const tooltipVisible = ref(false);
  const showBackTop = ref(false);

  const showTooltip = () => {
    tooltipVisible.value = true;
  };

  const hideTooltip = () => {
    tooltipVisible.value = false;
  };

  const handleScroll = () => {
    showBackTop.value = window.scrollY > 300;
  };

  onMounted(() => {
    resizeHandler();
    listenerResize();
    addDraggableListener();
    window.addEventListener("scroll", handleScroll);
    handleScroll(); // 初始检查
  });

  onUnmounted(() => {
    window.removeEventListener("resize", resizeHandler);
    window.removeEventListener("scroll", handleScroll);
  });
</script>

<template>
  <div id="page-tools" class="page-tools">
    <a-tooltip
      v-if="store.login"
      overlay-class-name="custom-tips-overlay page-tools-container"
      trigger="click"
      placement="left"
      v-model:open="tooltipVisible"
      :get-popup-container="getPopupContainer"
      :align="{ offset: [-10, 0] }">
      <template #title>
        <div class="customer-tooltip-content">
          <OnlineCustomer v-if="tooltipVisible" @close="hideTooltip" />
        </div>
      </template>
      <div ref="kefuRef" class="page-tools-service" @click="showTooltip">
        <icon-font type="Group419" />
        <p>在线客服</p>
      </div>
    </a-tooltip>
    <a-tooltip
      v-else
      v-model:open="visible"
      overlay-class-name="qrcode-tips-overlay"
      trigger="click"
      placement="leftTop"
      :get-popup-container="getPopupContainer">
      <template #title>
        <img class="tw-h-50 tw-w-40" src="~/assets/images/qrcode/www-service1.png" />
      </template>
      <div ref="kefuRef" class="page-tools-service">
        <icon-font type="Group419" />
        <!-- <Icon name="custom:group419" />-->
        <p>在线客服</p>
      </div>
    </a-tooltip>

    <div v-show="showBackTop" class="page-tools-back-top" @click="onBackTop">
      <icon-font type="huidaodingbu1" />
      <span>返回顶部</span>
    </div>
  </div>
</template>
<style lang="less">
  .page-tools-container .ant-tooltip-inner {
    padding: 0 !important;
  }

  // .page-tools-container .ant-tooltip-arrow,
  .qrcode-tips-overlay .ant-tooltip-arrow {
    opacity: 0 !important;
  }
</style>
<style scoped lang="less">
  .page-tools {
    position: fixed;
    top: 58%;
    right: 30px;
    z-index: 999;
    width: 64px;

    .page-tools-service {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 83px;
      margin-bottom: 24px;
      font-size: 12px;
      line-height: 14px;
      color: #505050;
      cursor: pointer;
      background: #fff;
      border-radius: 16px;
      box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 12%);

      .anticon {
        margin-bottom: 12px;
        font-size: 22px;
      }
    }

    .page-tools-back-top {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 83px;
      font-size: 12px;
      line-height: 14px;
      color: #505050;
      cursor: pointer;
      background: #fff;
      border-radius: 16px;
      box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 12%);

      .anticon {
        margin-bottom: 8px;
        font-size: 22px;
      }

      span {
        font-size: 12px;
        line-height: 14px;
        color: #505050;
      }
    }

    :deep(.qrcode-tips-overlay) {
      position: fixed !important;
      right: 96px !important;
      bottom: 128px !important;
      width: 198px;
      height: 198px;
      padding: 16px;
      background: #fff;
      border-radius: 8px;
      box-shadow: none;

      .ant-tooltip-inner {
        padding: 0;
        background: none;
        box-shadow: none;
      }

      .ant-tooltip-arrow {
        display: none !important;
      }

      .qrcode-image {
        display: block;
        width: 160px;
        height: 160px;
        margin: auto;
      }
    }
  }
</style>
